// ----
// JS for Toolbar
// ----

var SCM = SCM || {};

(function (ns, $, $document, undefined) {
    // ----
    // private variables and functions
    // ----
    var $toolbar = $('#Toolbar'),
        $viewDrop = $('#ViewsDrop'),
        $shareDrop = $('#ShareDrop'),
        $toolsDrop = $('#ToolsDrop');

    function showProperToolbarOptions() {
        hideActiveTabLinkFromViewsList();
        hideMenuItemIfNoVisibleItemsInside();
    }

    function hideMenuItemIfNoVisibleItemsInside() {
        var $ddTriggers = $('.item-with-dropdown:visible');
        $ddTriggers.show();
        $ddTriggers.each(function () {
            var visibleItemsExist = false,
                $this = $(this);

            $this.find('ul li, .js-article-content-filter').each(function () {
                if ($this.is(':visible')) {
                    visibleItemsExist = true;
                } else if ($this.css('display') !== 'none') {
                    visibleItemsExist = true;
                }
            });
            if (!visibleItemsExist) {
                $this.hide();
            }
        });
    }

    function hideActiveTabLinkFromViewsList() {
        $('.tab-item').parent('li').show();

        if ($('.tabs-content').length) {
            var activeTab = '';

            $('.tabs-content > .content').each(function () {
                var $this = $(this);
                if ($this.hasClass('active')) {
                    activeTab = $this.attr('id');
                }
            });
            $('#ViewsDrop li').show();
            $('#ViewsDrop').find('[data-tab="#' + activeTab + '"]').closest('li').hide();
        }
    }



    // ----
    // public methods and properties accessible by SCM.IssuePage.[method_name]
    // ----
    ns.closeDropDownIfChildItemClicked = function () {
        $('#Toolbar .f-dropdown > li').on('click', function () {
            $(this).closest('.toolbar-item').trigger('click');
        });
    };

    ns.removeTabLinkIfTabIsEmpty = function (cssSelector) {
        $(cssSelector).find('.tab-trigger').each(function () {
            var $this = $(this),
                tabName = $this.attr('data-tab');

            // find('*') grabs all descendent HTML elements so we can count.
            // if there are less than 20 Elements, the tab might be empty. Do a further check to validate
            // that the widget didn't output any content. Remove toolbar link if widget didn't output any content.
            // We don't want to do a costly regex replace if the widget outputs a large chunk of HTML.
            if (tabName !== '#ContentTab' && $(tabName).find('*').length < 20) {
                var html = $(tabName).html();
                var regex = /(<([^>]+)>)/ig;
                var result = html !== undefined ? $.trim(html.replace(regex, '')) : 1;

                if (result.length === 0) {
                    $this.parent('li').remove();
                }
            }
        });
    };

    ns.hideTabIfDropdownIsEmpty = function () {
        var dropdowns = [$shareDrop, $toolsDrop];

        for (var i = 0; i < dropdowns.length; i++) {
            var currentDd = dropdowns[i];
            if (currentDd.children('li').length < 1) {
            //there should always be at least a ContentTab li.
                currentDd.parent().hide();
                //If it's the only one, remove from toolbar
            }
        }
        if ($viewDrop.children('.js-article-content-filter').length < 2) {
            $viewDrop.parent().hide();
        }
    };

    ns.toggleToolbarDropdown = function () {
        $('.js-toolbar-dropdown').on('click', function (e) {
            e.preventDefault();

            var $this = $(this);

            $this.siblings('ul').slideToggle();
        });

        $(document).on('click', function (e) {
            var $dropdownContent = $('.js-dropdown-content');
            if (_isTargetClickNotInElement(e, $dropdownContent) && _isTargetClickNotInElement(e, $('.js-toolbar-dropdown'))) {
                $dropdownContent.slideUp();
            }
        });
    };

    ns.collapseShareDropdownOnTab = function () { 
        // Hide the dropdown when tabbing away from it
        // Tabbing forwards from last dropdown element
        $('.js-dropdown-content :last-child .js-share-link').on('keydown', function (event) {
            if (event.key === 'Tab' && !event.shiftKey) {
                $('.js-dropdown-content').slideUp();
            }
        });
        // Tabbing backwards from dropdown trigger
        $('.js-toolbar-dropdown').on('keydown', function (event) {
            if (event.key === 'Tab' && event.shiftKey) {
                $('.js-dropdown-content').slideUp();
            }
        });
    };

    ns.toggleTabContent = function () {
        $('.tab-trigger').on('click', function (e) {
            e.preventDefault();
            
            var $this = $(this),
                tabId = $this.attr('data-tab'),
                $tab = $(tabId);
            
            $tab.siblings().removeClass('active');
            $tab.addClass('active');

            if (tabId === '#FigureTab') {
                $document.trigger('scroll'); // Trigger scroll so lazy load can load images.
            }
            showProperToolbarOptions();
        });
    };

    function toolBarItemsCauseWrapInFullWidthMode() {
        var numToolbarItems = $('.toolbar-item:visible');
        return numToolbarItems.length > 6;
    }

    function adjustToolbarRightMargins() {
        $('.toolbar-item').css('marginRight', '.65em');
        $('.toolbar-item:last-child').css('margin-right', '0');
    }

    // When adding the Annotate button in some cases, the toolbar wraps in full width mode
    ns.adjustToolbarMargins = function () {

        if (toolBarItemsCauseWrapInFullWidthMode()) {
            adjustToolbarRightMargins();
        }
    };

    ns.styleToolbarStates = function() {
        $toolbar.on('click', '.toolbar-item', function() {
            var $this = $(this);
            $this.addClass('clicked');
            $this.siblings().removeClass('clicked');
        });

        var $toolbarItems = $('.toolbar-item');

        $document.on('click', function() {
            $toolbarItems.each(function() {
                var $this = $(this);
                if (!$this.find('ul').hasClass('open')) {
                    $this.removeClass('clicked');
                }
            });
        });

        
        // Note: this is not ideal, but the only good technical way to fix the problem
        // as of 24 Jun 2019. Toolbar <li> elements with no content need to be hidden. 
        // :empty does not work because of whitespace. When/if :blank is implemented
        // for all supported browsers, that should replace the following map function.
        // https://css-tricks.com/almanac/selectors/b/blank/
        $.map($toolbarItems, function (toolbarElement) {
            if (!toolbarElement.children.length) {
                toolbarElement.classList.add('no-children');
            }
        });
    };


    ns.initArticleContentFilter = function () {
        if ($(document.body).hasClass('pg_ChapterStandard')) {
            contentFilter('.widget-BookSectionsText', 'BookSectionsText');
        }
        else {
            contentFilter('.widget-ArticleFulltext', 'ArticleFulltext');
        }
    };

    function contentFilter(widget,dataName) {
        var $fullTextContent = $(widget, '#ContentTab');

        if ($fullTextContent.length) {
            var $contentSections = $('.widget-items[data-widgetname="' + dataName + '"]').children(); //$fullTextContent.find('.content-section');
            var $filterMenu = $viewDrop.children('.js-article-content-filter');

            $filterMenu.filter('[data-content-filter="article-content"]').hide();

            var $figuresTablesContent = $contentSections.filter('.table-wrap, .fig-section, .figure-title').add($contentSections.has('.table-wrap, .fig-section'));
            if ($figuresTablesContent.length === 0) {
                $filterMenu.remove('[data-content-filter="figures-tables"]');
            }

            var $videoContent = $contentSections.filter('.video-section');
            if ($videoContent.length === 0) {
                $filterMenu.remove('[data-content-filter="video"]');
            }

            var $audioContent = $contentSections.filter('.audio-section');
            if ($audioContent.length === 0) {
                $filterMenu.remove('[data-content-filter="audio"]');
            }

            var $supplementaryDataContent = $contentSections.has('.widget-ArticleDataSupplements, .supplementary-material');
            if ($supplementaryDataContent.length === 0) {
                $filterMenu.remove('[data-content-filter="supplementary-data"]');
            }

            var $downloadAllImages = $('#ContentTab').find('.js-download-images-ppt');

            var $commentsSection = $('#ContentTab').find('div.comments');

            var setDownloadImageLink = function ($contentSections) {
                // Need to do both filter and find to include parents and children
                if ($contentSections.filter('.fig-section:not(:has(a[restricted]))').length || 
                    $contentSections.find('.fig-section:not(:has(a[restricted]))').length) {
                    $downloadAllImages.show();
                }
                else {
                    $downloadAllImages.hide();
                }
            };


            $filterMenu.on('click', function () {

                var contentFilter = $(this).attr('data-content-filter');
                var $endNotesWidget = $('#endNotesTargetLocation');

                var activeContentFilter = $('.js-article-content-filter[data-content-filter="' + contentFilter + '"]');
                activeContentFilter.hide();
                activeContentFilter.siblings().show();

                var $metadataStandalone = $('.article-metadata-standalone-panel');

                var $filteredContent;

                if (contentFilter === 'figures-tables') {
                    $filteredContent = $figuresTablesContent;
                }
                else if (contentFilter === 'video') {
                    $filteredContent = $videoContent;
                }
                else if (contentFilter === 'audio') {
                    $filteredContent = $audioContent;
                }
                else if (contentFilter === 'supplementary-data') {
                    $filteredContent = $supplementaryDataContent;
                }

                if ($filteredContent !== undefined && $filteredContent !== null && $filteredContent.length) {
                    $contentSections.hide();
                    $supplementaryDataContent.hide();
                    $filteredContent.show();
                    $commentsSection.hide();
                    setDownloadImageLink($filteredContent);
                    if ($endNotesWidget.length) {
                        $endNotesWidget.hide();
                    }
                }
                else {
                    $contentSections.show();

                    // NARN-10700 (adjust code from NARN-5642): make sure there are children before showing, e.g.,
                    //                                          when switching from split view or figure view.
                    $metadataStandalone.children().length > 0 ? $metadataStandalone.show() : $metadataStandalone.hide();

                    $supplementaryDataContent.show();
                    $commentsSection.show();
                    $downloadAllImages.hide();
                    if ($endNotesWidget.length) {
                        $endNotesWidget.show();
                    }
                }

                SCM.SiteJS.restrictedImages();
            });
        }
    }

    ns.closeHypothesis = function () {
        $('hypothesis-sidebar').css('display', 'none');
        document.body.style.setProperty('margin-right', '0px');
    };

    function closeDropdowns() {
        $('.site-menu-lvl-0').find('.site-menu:visible').slideToggle('fast');
        $('.f-dropdown:visible').slideToggle('fast');
        $('.js-login-box-placeholder').addClass('hide');
    }

    function openCloseHypothesis() {
        if ($('hypothesis-sidebar:visible').length ) {
            ns.closeHypothesis();
        } else {
            closeDropdowns();
            $('hypothesis-sidebar').css('display', 'block');
            $('[data-hypothesis-trigger]').click();
        }
    }

    function _isTargetClickNotInElement(e, $element) {
        return !$element.is(e.target) && !$element.has(e.target).length;
    }
    
    ns.registerAnnotateLink = function () {
        $('.js-annotate').off('click').on('click', function () {
            openCloseHypothesis();
        });
    };

    function isBtnClicked(e, pathName) {
        var btn = undefined;
        if (e.originalEvent) {
            var path = e.originalEvent.composedPath ? e.originalEvent.composedPath() : undefined;
            if (path !== undefined) {
                btn = path.find(function (el) {
                    if (el.attributes !== undefined && el.attributes['aria-label'] !== undefined) {
                        return el.attributes['aria-label'].value === pathName;
                    }
                    else {
                        return false;
                    }
                });
            }
        }
        return btn;
    }

    
    // checking if button is sidebar toggle
    // The button information is hidden deep in the event!
    function sideBarBtnToggleClicked(e) {
        var btnClicked = isBtnClicked(e, 'Annotation sidebar');
        return btnClicked !== undefined;
    }

    function handleClicksForHypothesis(e) {
        
        var sideBarClick = e.target.localName === 'hypothesis-sidebar'; 
       
        // NOTE: the 'hide' class doesn't work properly for this, so using direct styles
        if (sideBarClick && sideBarBtnToggleClicked(e)) {
            $('hypothesis-sidebar').css('display', 'none');
            return;
        }
        var $target = $(e.target);
        var hypothesisBtn = e.target.localName.startsWith('hypothesis');
        // if clicking on highlighted text or annotating text, Hypothes.is activates
        // but only seems to open sidebar - so need to click to expand
        if (hypothesisBtn) {
            $('hypothesis-sidebar').css('display', 'block');
            $('[data-hypothesis-trigger]').click();
        }
        // if we didn't click the annotate link, close it all up and hide it
        else if ($target.attr('data-hypothesis-trigger') === undefined && !$target.hasClass('js-annotate')) {
            $('hypothesis-sidebar').css('display', 'none');
        }
    }


    ns.hypothesisConfig = function () {

        if ($('.js-annotate').length) {
            ns.registerAnnotateLink();
            ns.configureHypothesisLayoutFix();

            // Make sure the hypothes.is sidebar is loaded before hiding it
            // Otherwise the data-hypothesis-trigger to open it won't work
            SCM.Retry.policy()
                .handleResult(function (result) { return !result; }) // Retry when our execute function returns false
                .waitAndRetry(5, 500) // Retry 5 times, waiting 500ms between each try
                .execute(function () {
                    return $('hypothesis-sidebar:visible').length;
                })
                .then(function () {
                    $('hypothesis-sidebar').css('display', 'none');
                })
                .catch(function () {
                    console.error('Timed out waiting for Hypothes.is to be ready.');
                });

            // Hypothes.is has their own handlers to close the expanded sidebar when you click outside of it
            // That action leaves the sidebar icons displayed, so we have to hide them
            // BUT, we don't want to hide them if we've actually clicked on the annotate buttons to open it!
            $(document).on('click', handleClicksForHypothesis);

            
            window.hypothesisConfig = function () {
                return {
                    'openSidebar': true,
                    'onLayoutChange': function (e) {
                        // Hacky way to get around Hypothes.is touch event handlers  
                        // In mobile view, clicking on the annotate link also generates a touch event
                        // Hypothes.is sees this as the following:  
                        //      js-annotate click ==> expand sidebar
                        //      touch event ==> clicked outside sidebar so now CLOSE the sidebar!
                        // so we force the sidebar to re-open by re-clicking the data-hypothesis-trigger
                        // But we only want to do this if the sidebar is actually visible (we're in the open it path)
                        // and it's not already expanded.
                        // The 'onLayoutChange' event is provided by Hypothes.is to indicate size changes in their display
                        // see https://h.readthedocs.io/projects/client/en/latest/publishers/config/ for more info
                        if (e.width < 50 && e.width !== 0 && $('hypothesis-sidebar:visible').length) {
                            $('[data-hypothesis-trigger]').click();
                        }
                    }
                };
            };
        }
    };

    ns.configureHypothesisLayoutFix = function () {
        const targetNode = document.body;
        const config = { attributes: true, attributeFilter: ['style'] };
        const callback = (mutationList) => {
            for (const mutation of mutationList) {
                if (mutation.type === 'attributes' &&
                    mutation.attributeName === 'style' &&
                    document.body.style.marginRight &&
                    !$('hypothesis-sidebar:visible').length) {
                    document.body.style.setProperty('margin-right', '0px');
                }
            }
        };
        const observer = new MutationObserver(callback);
        observer.observe(targetNode, config);
    };

    ns.init = function () {
        if ($toolbar.length) {
            showProperToolbarOptions();
            ns.removeTabLinkIfTabIsEmpty($viewDrop);
            ns.styleToolbarStates();
            ns.toggleToolbarDropdown();
            ns.collapseShareDropdownOnTab();
            ns.toggleTabContent();
            ns.initArticleContentFilter();
            ns.hideTabIfDropdownIsEmpty();
            ns.hypothesisConfig();
            ns.adjustToolbarMargins();
        }
        SCM.CitationModal.enableCitationDownloadOnFormatSelect();
    };

})(SCM.Toolbar = SCM.Toolbar || {}, jQuery, $(document));